<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogMain.type == 'create'">Nuevo Periodo </h3>
                <h3 v-else>Editar Periodo </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <PeriodoForm :model="periodo" :on-success="savePeriodo" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PeriodoForm from '@/components/forms/PeriodoForm'
export default {
  data: () => ({
    periodo: {
    }
  }),
  components: {
    PeriodoForm
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction']),
    savePeriodo (model) {
      this.periodo = model
      this.getUrl('period.store')
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.periodo })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_MAIN', 'CLEAR_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrl('period.store')
    },
    get_object (val) {
      console.log(val)
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.SET_DATA_MAIN(val)
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'El Periodo ha sido guardado.!'
      })
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>

</style>
